import { handleApiError, phpApi } from "../default";

export const fetchCertificatePaths = () => {
  return phpApi.get("/api/certificate-path").catch(handleApiError);
};

export const fetchCertificate = (id) => {
  return phpApi.get(`/api/certificate-path/${id}`).catch(handleApiError);
};
